import React from 'react';
import './TextBox.scss';

const TextBox = () => {
  return (
    <div className="text-box">
      <div className="title">Kind tips</div>
      <div className="content">
      [Upload photos] Please note that if the uploaded photos are blurry or occluded objects,
         Unable to upload, you will not be able to upload photos with our photos without objection
         Upload, notify us to upload photos without blurring the photos.
         Such as uploading and receiving unobjectionable transmission cannot be related to our photos, and surrounding cannot
         Normally send your direction, serious melons.
      </div>
    </div>
  );
};

export default TextBox;
